import {
  createGroupActionButtons,
  createStatusTag,
  createStoreActionButtons,
  renderZipCodes,
} from "./storeConstants";

export const transformStoresToRowData = (stores, onEdit, onDelete) => {
  return stores.map((store) => ({
    storeId: store.metadata?.store_id || "-",
    name: store.name,
    retailer: store.metadata?.retailer || "-",
    city: store.metadata?.city || "-",
    state: store.metadata?.state || "-",
    postcode: store.metadata?.postcode || "-",
    country: store.metadata?.country || "-",
    category: store.category || "-",
    status: createStatusTag(store.deleted),
    actions: createStoreActionButtons(store, onEdit, onDelete),
  }));
};

export const transformGroupsToRowData = (
  groups,
  onViewGroup,
  onEditGroup,
  onDeleteGroup
) => {
  return groups.map((group) => ({
    name: group.name,
    storeCount: group.storeCount,
    zipCodes: renderZipCodes(group.zipCodes),
    actions: createGroupActionButtons(
      group.name,
      onViewGroup,
      onEditGroup,
      onDeleteGroup
    ),
  }));
};

export const STORE_EXPORT_CSV_HEADERS = [
  "Store Id",
  "Name",
  "Retailer",
  "Address",
  "Postcode",
  "City",
  "State",
  "Country",
  "Latitude",
  "Longitude",
  "Categories",
];

const escapeCsvField = (value) => {
  const str = value == null ? "" : String(value);
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const buildStoresCsv = (stores) => {
  const rows = stores.map((store) => {
    const metadata = store.metadata || {};
    const geo = metadata.geolocation || {};
    return [
      metadata.store_id,
      store.name,
      metadata.retailer,
      metadata.address,
      metadata.postcode,
      metadata.city,
      metadata.state,
      metadata.country,
      geo.latitude,
      geo.longitude,
      store.category,
    ]
      .map(escapeCsvField)
      .join(",");
  });
  return [STORE_EXPORT_CSV_HEADERS.join(","), ...rows].join("\n");
};

export const downloadStoresCsv = (stores, filename = `stores-${Date.now()}.csv`) => {
  const blob = new Blob([buildStoresCsv(stores)], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
};
